module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_2.155f8aa1.png";